import { render, staticRenderFns } from "./bom_file.vue?vue&type=template&id=035ac584&scoped=true"
import script from "./bom_file.vue?vue&type=script&lang=js"
export * from "./bom_file.vue?vue&type=script&lang=js"
import style0 from "./bom_file.vue?vue&type=style&index=0&id=035ac584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035ac584",
  null
  
)

export default component.exports